import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';

import { AuthService } from '../core/auth.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { Unlockdconfig } from '../../unlockd.config';

/**
 * Api services for the `NotificationsApi` model.
 */
@Injectable({
  providedIn: 'root',
})
export class NotificationsApi {
  constructor(protected http: HttpClient, private authService: AuthService) {}

  public getNotificationsByUserId(pageIndex = 1, limit = 3): Observable<any> {
    let offset;
    if (pageIndex === 1) {
      offset = 0;
    } else {
      offset = (pageIndex - 1) * limit;
    }

    const url =
      Unlockdconfig.getPath() +
      `/notifications/users?offset=${offset}&limit=${limit}`;

    return this.http.get(url, {
      headers: new HttpHeaders().set(
        'Authorization',
        this.authService.getAccessTokenId()
      )
    });
  }
  public updateNotificationsById(notification_id, status): Observable<any> {
    const url = Unlockdconfig.getPath() + `/notifications/${notification_id}`;

    return this.http.put(
      url,
      { status },
      {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        )
      }
    );
  }
  public markAllReadNotifications(notification_array): Observable<any> {
    const url = Unlockdconfig.getPath() + `/notifications/mark/true`;

    return this.http.put(
      url,
      { notification_array },
      {
        headers: new HttpHeaders().set(
          'Authorization',
          this.authService.getAccessTokenId()
        )
      }
    );
  }
}
